export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }

    if (time === null || time === '') {
        return null
    }

    if ((time + '').length === 10) {
        time = +time * 1000
    }

    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        date = new Date(parseInt(time))
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return timeStr
}
export function formatPeople(str, format) {
    if (arguments.length === 0) {
        return null
    }
    if (str === null || str === '') {
        return null
    }
    let result = null
    let arr = str.split('，法定代表人')
    if (arr.length === 1) {
        return str
    } else if (arr.length === 2) {
        if (format === 0) {
            result = arr[0]
        } else if (format === 1) {
            result = '法定代表人' + arr[1]
        }
    }
    return result
}

// 阿拉伯数字改为中文
export function int2Chinese(num) {
    var china = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
    var arr = new Array();
    var english = String(num).split("");
    for (var i = 0; i < english.length; i++) {
        arr[i] = china[english[i]];
    }
    return arr.join("")
}

// 身份证获取出生日期
export function dateformat(idcard) {
    return idcard.substring(6, 10) + "年" + parseInt(idcard.substring(10, 12)) + "月" + parseInt(idcard.substring(12, 14)) + "日";
}
// 身份证获取性别
export function getSex(idcard) {
    if (!idcard) {
        return false;
    }
    return idcard.substring(16, 17) == '1' ? "男" : "女";
}